import { useState, useEffect, useCallback } from "react";
import { IHeaderParams } from "ag-grid-community";
import { Checkbox } from "@mui/material";
import React from "react";

interface CustomHeaderCheckboxProps extends IHeaderParams {}

const CustomHeaderCheckbox: React.FC<CustomHeaderCheckboxProps> = (props) => {
  const [checked, setChecked] = useState<boolean>(false);

  const updateHeaderCheckboxState = useCallback(() => {
    let totalFiltered = 0;
    let checkedCount = 0;

    props.api.forEachNodeAfterFilter((node) => {
      totalFiltered++;
      if (node.data?.fixCheckbox === true) {
        checkedCount++;
      }
    });

    // 모든 필터링된 row가 체크된 경우에만 true
    setChecked(totalFiltered > 0 && checkedCount === totalFiltered);
  }, [props.api]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setChecked(isChecked);

    props.api.forEachNodeAfterFilter((node) => {
      node.setDataValue("fixCheckbox", isChecked);
    });
  };

  // 최초 mount 및 row 변경시 상태 동기화
  useEffect(() => {
    updateHeaderCheckboxState();

    const onCellValueChanged = () => updateHeaderCheckboxState();
    const onFilterChanged = () => updateHeaderCheckboxState();

    props.api.addEventListener("cellValueChanged", onCellValueChanged);
    props.api.addEventListener("filterChanged", onFilterChanged);

    return () => {
      props.api.removeEventListener("cellValueChanged", onCellValueChanged);
      props.api.removeEventListener("filterChanged", onFilterChanged);
    };
  }, [props.api, updateHeaderCheckboxState]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <label className="ag-checkbox" style={{ margin: 0 }}>
        <Checkbox
          className="ag-checkbox-input"
          checked={checked}
          onChange={onChange}
          sx={{
            height: "30px",
            "& .MuiSvgIcon-root": {
              fontSize: 22,
            },
            alignContent: "center",
            color: "#7d7e80",
          }}
        />
      </label>
    </div>
  );
};

export default CustomHeaderCheckbox;
